import React from "react"

import Style from "./title.module.scss"
/**
 * Title: Title header for main conteent
 */
const Title = props => {
  const { title, subtitle, author, date } = props

  return (
    <>
      {/** Content Title */}
      <h1 className={Style.editorialTitle}>{title.toUpperCase()}</h1>
      <Subtitle subtitle={subtitle} />
      <hr />
      <Author author={author} />
      {/** Content Date */}
      <h6 className={Style.editorialDate}>{date}</h6>
      <br />
    </>
  )
}

export default Title

/* ===================================================*/

const Subtitle = props => {
  if (props.subtitle != null) {
    return (
      <h3
        style={{ marginBottom: "1vw", marginTop: "-1vw", textAlign: "center" }}
      >
        {props.subtitle}
      </h3>
    )
  } else return null
}

const Author = props => {
  if (props.author != null) {
    return (
      <h4 style={{ margin: "0.5vw", paddingTop: "1vw", textAlign: "center" }}>
        by {props.author}
      </h4>
    )
  } else return <div style={{ marginBottom: "2vw" }} />
}
